import { render, staticRenderFns } from "./historical-update.vue?vue&type=template&id=22c7bf61&scoped=true&"
import script from "./historical-update.vue?vue&type=script&lang=js&"
export * from "./historical-update.vue?vue&type=script&lang=js&"
import style0 from "./historical-update.vue?vue&type=style&index=0&id=22c7bf61&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c7bf61",
  null
  
)

export default component.exports